import React, { useState } from 'react';
import { authService, saveSession } from '../api/auth';
import './Login.css';

const Login: React.FC<{ onLogin: () => void }> = ({ onLogin }) => {
  const [pinCode, setPinCode] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const submit = async (event: React.FormEvent) => {
    event.preventDefault();
    if (!/^-?\d+$/.test(pinCode.trim())) return setError('Введите корректный пин-код');
    setLoading(true); setError('');
    try {
      const response = await authService.login(pinCode.trim());
      saveSession(response);
      onLogin();
    } catch (cause: any) {
      setError(cause.response?.data?.detail || cause.message || 'Ошибка подключения');
    } finally { setLoading(false); }
  };
  return <div className="login-container"><div className="login-form">
    <div className="logo-container"><img src="/logo_education.png" alt="Иннопрог" className="logo" /></div>
    <form onSubmit={submit}>
      <div className="form-group"><label htmlFor="pin-code">Пин-код</label><input id="pin-code" value={pinCode} onChange={(e) => setPinCode(e.target.value.replace(/[^\d-]/g, ''))} disabled={loading} /></div>
      {error && <div className="error-message">{error}</div>}
      {loading && <div className="login-progress" role="status"><span className="login-progress-spinner" />Проверяем доступ к чатам Avito…</div>}
      <button type="submit" className="login-button" disabled={loading}>Войти</button>
    </form>
  </div></div>;
};

export default Login;
